import { apiServiceConstants } from "../../constants";
import { apiService, utilService } from "../../services";
import {
  BedListApiResponse,
  BedStatusApiResponse,
  ProcessedBedsData,
  setAssignStatusApiRequest,
  SiteObject,
  UnitObject,
} from "./UnitBedsDataModel";

const handleBedListResponse = (
  apiResponse: BedListApiResponse,
  isResponseSuccess: boolean
) => {
  if (isResponseSuccess === true) {
    const response = apiResponse as BedListApiResponse;
    return {
      isSuccess: response.isSuccess,
      message: response.message,
      bedsData: response.result?.[0]?.bedList,
      siteData: response.result?.[0]?.site,
      unitData: response.result?.[0]?.unit,
    } as ProcessedBedsData;
  } else if (isResponseSuccess === false) {
    const errorResponse = apiResponse as BedListApiResponse;
    return {
      isSuccess: errorResponse.isSuccess,
      message: errorResponse.message,
      bedsData: [],
      siteData: {} as SiteObject,
      unitData: {} as UnitObject,
    } as ProcessedBedsData;
  } else {
    return {} as ProcessedBedsData;
  }
};

const getBeds = async (reqParams: {}): Promise<ProcessedBedsData> => {
  return await apiService
    .apiCall(
      `sboard/unit/bed/list/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return handleBedListResponse(res as BedListApiResponse, true);
    })
    .catch((err) => {
      return handleBedListResponse(err, false);
    });
};

const getUnitId = () => {
  return window.location.pathname!.split("/")[2];
};

const setBedStatus = async (reqParams: {}): Promise<BedStatusApiResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/disable-bed/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res as BedStatusApiResponse;
    })
    .catch((err) => {
      return err as BedStatusApiResponse;
    });
};

const setAssignedStatus = async (
  reqParams: setAssignStatusApiRequest
): Promise<ProcessedBedsData> => {
  return await apiService
    .apiCall(
      `sboard/unit/assign-patient-v2/?hour=${reqParams.hour}&minute=${
        reqParams.minute
      }&date=${reqParams.date}&reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      return handleBedListResponse(res as BedListApiResponse, true);
    })
    .catch((err) => {
      return handleBedListResponse(err as BedListApiResponse, false);
    });
};

export const UnitBedsService = {
  getBeds,
  getUnitId,
  setBedStatus,
  setAssignedStatus,
};
